module.exports = __webpack_public_path__ + "static/media/2.780dd778.JPG";